var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("form", [
          _c("div", { staticClass: "panel panel-grey" }, [
            _c("div", { staticClass: "panel-body" }, [
              _c("div", { staticClass: "form-horizontal" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 col-lg-6" },
                    [
                      _c("field-input", {
                        attrs: {
                          model: _vm.$v.first_name,
                          "field-name": "First name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-12 col-lg-6" },
                    [
                      _c("field-input", {
                        attrs: {
                          model: _vm.$v.last_name,
                          "field-name": "Last name",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 col-lg-6" },
                    [
                      _c("field-input", {
                        attrs: { model: _vm.$v.email, "field-name": "Email" },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "panel-footer" },
              [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-sm btn-primary",
                    attrs: {
                      type: "submit",
                      click: _vm.handleAddInternCallback,
                    },
                  },
                  [_vm._v("\n              Add Intern\n            ")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Add Intern")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }